import React, { useState } from 'react';
import NavbarComponent from '../components/Navbar.jsx';
import Footer from '../components/Footer.jsx';
import { Container, Form, Button, Spinner, Image, Modal } from 'react-bootstrap';

function Digimon({ darkMode }) {
  const [digimonId, setDigimonId] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [imageIndex, setImageIndex] = useState(0);
  const [errorModal, setErrorModal] = useState({ show: false, message: '' });

  const closeModal = () => setErrorModal({ show: false, message: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!digimonId) return;
    setLoading(true);
    try {
      const response = await fetch(`https://digi-api.com/api/v1/digimon/${digimonId}`);
      if (!response.ok) throw new Error('not_found');
      const data = await response.json();
      const images = Array.isArray(data.images) ? data.images : [];
      setResult({ name: data.name, images });
      setImageIndex(0);
    } catch (err) {
      if (err.message === 'not_found') {
        setErrorModal({ show: true, message: `No Digimon found for ID ${digimonId}. Please try another ID.` });
      } else {
        setErrorModal({ show: true, message: 'Something went wrong. Please check your connection and try again.' });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={darkMode ? 'dark-mode' : ''}>
      <NavbarComponent />
      <Container className="section-card">
        <h1>Digimon</h1>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="digimonIdInput">
            <Form.Label>Digimon ID</Form.Label>
            <Form.Control
              type="number"
              min="1"
              value={digimonId}
              onChange={(e) => setDigimonId(e.target.value)}
              placeholder="Enter Digimon ID"
            />
          </Form.Group>
          <Button type="submit" disabled={loading}>
            {loading ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />{' '}
                Searching...
              </>
            ) : (
              'Search'
            )}
          </Button>
        </Form>

        {result && (
          <div className="mt-4">
            <h2>{result.name}</h2>
            {result.images.length > 0 && (
              <>
                <Image
                  src={result.images[imageIndex].href}
                  alt={`${result.name} - image ${imageIndex + 1}`}
                  fluid
                />
                <div className="mt-2 d-flex align-items-center gap-2">
                  <Button
                    variant="secondary"
                    onClick={() => setImageIndex((i) => i - 1)}
                    disabled={imageIndex === 0}
                    aria-label="Previous image"
                  >
                    Previous
                  </Button>
                  <span aria-label="Image counter">{imageIndex + 1} / {result.images.length}</span>
                  <Button
                    variant="secondary"
                    onClick={() => setImageIndex((i) => i + 1)}
                    disabled={imageIndex === result.images.length - 1}
                    aria-label="Next image"
                  >
                    Next
                  </Button>
                </div>
              </>
            )}
          </div>
        )}
      </Container>
      <Modal show={errorModal.show} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorModal.message}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
    </div>
  );
}

export default Digimon;
